<script setup>
import { maska as vMask } from 'maska'

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
  },
  label: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  autofocus: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: Number,
    default: 100,
  },
  mask: {
    type: [Array, Object, String],
  },
  tabindex: {
    type: Number,
  },
  type: {
    type: String,
    default: 'text',
  },
  v: {
    type: Object,
    required: true,
  },
})

const emits = defineEmits(['update:modelValue', 'blur', 'changed'])

const theme = inject('widgetTheme')
const i18n = inject('i18n')

const vFocus = {
  mounted: el => props.autofocus ? el.focus() : false,
}

function getErrorMsg(err) {
  if (err) {
    if (err.$params.msg)
      return err.$params.msg
    if (err.$message)
      return err.$message
  }
}

const errors = computed(() => {
  return props.v.$errors.slice(0, 1)
})

watch(
  () => props.modelValue,
  (newVal, oldVal) => {
    if (newVal !== oldVal)
      emits('changed')
  },
)
</script>

<template>
  <div class="cd-form__input-container" :class="[theme !== 'default' ? `cd-${theme}-label` : '', errors.length > 0 ? 'cd-form-error' : '']">
    <template v-if="theme === 'material'">
      <input
        :id="name"
        v-focus
        v-mask="mask"
        :type="type"
        :maxlength="maxlength"
        :value="modelValue"
        :placeholder="placeholder ? placeholder : ''"
        :tabindex="tabindex"
        :name="name"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur')"
      >
      <slot />
      <div class="cd-form__label-container">
        <label :for="name">{{ label }} <span v-if="placeholder" class="hide-focus">({{ placeholder }})</span></label>
        <span v-if="!required" class="optional-tag">{{ i18n.global.t('form.optional') }}</span>
      </div>
    </template>
    <template v-else>
      <div class="cd-form__label-container">
        <label :for="name">{{ label }}</label>
        <span v-if="!required" class="optional-tag">{{ i18n.global.t('form.optional') }}</span>
      </div>
      <div class="cd-form__input">
        <input
          :id="name"
          v-focus
          v-mask="mask"
          :type="type"
          :maxlength="maxlength"
          :value="modelValue"
          :placeholder="placeholder ? placeholder : ''"
          :tabindex="tabindex"
          :name="name"
          v-bind="$attrs"
          @input="$emit('update:modelValue', $event.target.value)"
          @blur="$emit('blur')"
        >
        <slot />
      </div>
    </template>
    <FormError :message="getErrorMsg(errors[0])" />
  </div>
</template>
